import type { Operation } from "@gui-creator/gemeinsam";

const GRENZE = 200;

type Schritt = { umkehr: Operation[]; vor: Operation[] };

/** Rückgängig nur für eigene Schritte dieser Sitzung; ein neuer Schritt verwirft die Wiederholung. */
export class Rueckgaengig {
  private zurueck: Schritt[] = [];
  private vorwaerts: Schritt[] = [];

  merken(umkehr: Operation[], vor: Operation[]): void {
    if (umkehr.length === 0) return;
    this.zurueck.push({ umkehr, vor });
    if (this.zurueck.length > GRENZE) this.zurueck.shift();
    this.vorwaerts = [];
  }

  rueckgaengig(): Operation[] | null {
    const s = this.zurueck.pop();
    if (!s) return null;
    this.vorwaerts.push(s);
    return s.umkehr;
  }

  wiederholen(): Operation[] | null {
    const s = this.vorwaerts.pop();
    if (!s) return null;
    this.zurueck.push(s);
    return s.vor;
  }

  kannZurueck(): boolean {
    return this.zurueck.length > 0;
  }

  kannVor(): boolean {
    return this.vorwaerts.length > 0;
  }

  leeren(): void {
    this.zurueck = [];
    this.vorwaerts = [];
  }
}
